import { render, staticRenderFns } from "./AnnotationLinksPreview.vue?vue&type=template&id=096bf919&scoped=true&"
import script from "./AnnotationLinksPreview.vue?vue&type=script&lang=js&"
export * from "./AnnotationLinksPreview.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationLinksPreview.vue?vue&type=style&index=0&id=096bf919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096bf919",
  null
  
)

export default component.exports